import { alpha, Box, Typography, useTheme } from "@mui/material";
import { Clock, Link2 } from "lucide-react";
import type { FC } from "react";
import { PinContractChoiceRow } from "web_myplann/Goals/Components/PinContract/PinContractChoiceRow";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { SUCCESS_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

type Props = {
	open: boolean;
	onClose: () => void;
	onPickExisting: () => void;
	onPickFuture: () => void;
};

export const PinContractChoiceDrawer: FC<Props> = ({
	open,
	onClose,
	onPickExisting,
	onPickFuture,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Goals.Detail.Solution.Pin.chooseTitle)}
			closeButton
		>
			<Box pb={spacingTokens.lg}>
				<Typography
					variant="caption"
					display="block"
					color={palette.grey[500]}
					px={spacingTokens.lg}
					pb={spacingTokens.md}
				>
					{t(Resources.Goals.Detail.Solution.Pin.chooseDescription)}
				</Typography>
				<PinContractChoiceRow
					onClick={onPickExisting}
					iconBg={palette.myPLANN.main10}
					iconColor={palette.myPLANN.main}
					Icon={Link2}
					title={t(Resources.Goals.Detail.Solution.Pin.existingTitle)}
					subtitle={t(Resources.Goals.Detail.Solution.Pin.existingDescription)}
					hasDivider
				/>
				<PinContractChoiceRow
					onClick={onPickFuture}
					iconBg={alpha(SUCCESS_MYPLANN_LIGHT, 0.2)}
					iconColor={SUCCESS_MYPLANN_LIGHT}
					Icon={Clock}
					title={t(Resources.Goals.Detail.Solution.Pin.futureTitle)}
					subtitle={t(Resources.Goals.Detail.Solution.Pin.futureDescription)}
				/>
			</Box>
		</MyPlannDrawer>
	);
};
